export type GetUserIntermediateDetailsSuccessResponseKeys =
  | 'intermediate_course_id'
  | 'course_name'
  | 'other_intermediate_course'
  | 'institute_id'
  | 'institute_name'
  | 'other_institute_name'
  | 'completion_status'
  | 'score_type'
  | 'score'
  | 'year_of_completion'
  | 'board_name_enum'
  | 'score_in_maths'
  | 'institute_state_name'
  | 'city_name'
  | 'first_year_score'
  | 'first_year_cert_s3_url'
  | 'second_year_cert_s3_url'
  | 'score_type';

const allSuccessKeys: GetUserIntermediateDetailsSuccessResponseKeys[] = [
  'intermediate_course_id',
  'course_name',
  'other_intermediate_course',
  'institute_id',
  'institute_name',
  'other_institute_name',
  'completion_status',
  'score_type',
  'score',
  'year_of_completion',
  'board_name_enum',
  'score_in_maths',
  'institute_state_name',
  'city_name',
  'first_year_score',
  'first_year_cert_s3_url',
  'second_year_cert_s3_url',
  'score_type'
];

const getUserIntermediateDetailsGraphQlQuery = (
  successKeys: GetUserIntermediateDetailsSuccessResponseKeys[],
  withQuery = true
): string => {
  const keysToUse = successKeys?.length ? successKeys : allSuccessKeys;

  const successFields = `success_response { ${keysToUse.join(' ')} }`;

  const failureFields = `failure_response { res_status response }`;

  if (withQuery) {
    return `
    query getUserIntermediateDetails{
      user_intermediate_details{
        ${successFields}
        ${failureFields}
      }
    }
  `;
  } else
    return `
    user_intermediate_details{
      ${successFields}
      ${failureFields}
    }
    `;
};

export { getUserIntermediateDetailsGraphQlQuery };
